export default function () {
	const iframes = document.querySelectorAll( '[data-iframe-loader] iframe' );
	if ( ! iframes) {
		return;
	}

	iframes.forEach((iframe) => {
		iframe.addEventListener('load', () => {
			iframe.closest('[data-iframe-loader]').classList.add('loaded');
		})
	})

}
